import { MENU_CLASSES } from '@interlayer/js/app/components/main/DefaultMenu/constants';

export const checkAvailablePage = (cssClasses) => {
    const cssClassesArray = cssClasses.split(' ') || [];

    return !cssClassesArray.some((current) => current.trim() === MENU_CLASSES.HIDDEN);
};
